export default "__VITE_ASSET__76665828__"